(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    var GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxzw7ftNRkTLDV8jPcv-0vSl1HHR5rNsFYtWGU24jLEyIxM36PWrTTUByytpsVHEF_P/exec';
    var letztGesendeteNummer = '';

    const checkbox   = document.getElementById('cart-beratung-checkbox');
    const phoneWrap  = document.getElementById('cart-beratung-phone-wrap');
    const phoneInput = document.getElementById('cart-beratung-phone-input');
    const statusInput = document.getElementById('cart-beratung-status');
    const cartForm   = document.getElementById('cart');
    const checkoutBtn = document.getElementById('checkout');

    if (!checkbox || !cartForm) return;

    function applyState(checked) {
      phoneWrap.style.display = checked ? 'block' : 'none';
      phoneInput.required     = checked;
      statusInput.value       = checked ? 'ja' : 'nein';
      if (!checked) {
        phoneInput.value = '';
        phoneInput.setCustomValidity('');
      }
    }

    // Restore persisted state from cart attributes on page load
    if (statusInput.value === 'ja') {
      checkbox.checked = true;
      applyState(true);
    }

    checkbox.addEventListener('change', function() {
      applyState(this.checked);
    });

    // Nummer an Google Sheet senden (re-sends wenn Nummer geändert)
    phoneInput.addEventListener('blur', function() {
      var nummer = this.value.trim();
      if (nummer !== '' && nummer !== letztGesendeteNummer) {
        letztGesendeteNummer = nummer;
        fetch(GOOGLE_SCRIPT_URL + '?telefonnummer=' + encodeURIComponent(nummer), { mode: 'no-cors' });
        phoneInput.style.borderColor = '#00b67a';
        setTimeout(function() { phoneInput.style.borderColor = ''; }, 2000);
      }
    });

    // Validate phone field before submit (both form submit + checkout button click)
    function validateBeratung(event) {
      if (checkbox.checked && phoneInput.value.trim() === '') {
        event.preventDefault();
        event.stopImmediatePropagation();
        phoneInput.focus();
        phoneInput.setCustomValidity('Bitte gib deine Telefonnummer ein.');
        phoneInput.reportValidity();
        phoneInput.addEventListener('input', function handler() {
          phoneInput.setCustomValidity('');
          phoneInput.removeEventListener('input', handler);
        });
      }
    }

    cartForm.addEventListener('submit', validateBeratung);
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', validateBeratung);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
